// @flow
import React, { Component } from "react";

import Mail from "react-feather/dist/icons/mail";
import { LinkedinShareButton, TwitterShareButton } from "react-share";
import urljoin from "url-join";
import TwitterIcon from "react-feather/dist/icons/twitter";
import LinkedinIcon from "react-feather/dist/icons/linkedin";
import SubscribeModal from "../../../shared/SubscribeModal/SubscribeModal";
import config from "../../../../../data/SiteConfig";
import styles from "./SocialShare.module.css";

type Props = {
  breach: PrismicBreach,
  className?: string
};

type State = {
  isSubscribeModalOpen: boolean
};

class SocialShare extends Component<Props, State> {
  static defaultProps = {
    className: ""
  };

  state = {
    isSubscribeModalOpen: false
  };

  toggleSubscribe = (e: Event) => {
    e && e.preventDefault;
    this.setState(prevState => ({
      isSubscribeModalOpen: !prevState.isSubscribeModalOpen
    }));
  };

  closeSubscribe = (e: Event) => {
    e && e.preventDefault;
    this.setState({
      isSubscribeModalOpen: false
    });
  };

  render() {
    const { isSubscribeModalOpen } = this.state;
    const { breach, className } = this.props;
    const { uid, data } = breach;
    const url = urljoin(config.siteUrl, uid);
    const description = `Leak discosed at: ${
      data.disclosed_at
    }.  Leak discovered at: ${data.discovered_at}.`;

    return (
      <div className={className}>
        <div className={styles.subscribeWrapper}>
          <div onClick={this.toggleSubscribe} className={styles.socialLink}>
            <Mail height={20} />
            {isSubscribeModalOpen
              ? `Subscribe via Email`
              : `Subscribe via Email`}
          </div>
          <SubscribeModal
            isSubscribeModalOpen={isSubscribeModalOpen}
            close={this.closeSubscribe}
          />
        </div>
        <TwitterShareButton
          url={url}
          title={data.title.text}
          className={styles.socialLink}
        >
          <TwitterIcon strokeWidth={1} />
          Share this on Twitter
        </TwitterShareButton>
        <LinkedinShareButton
          url={url}
          title={data.title.text}
          description={description}
          className={styles.socialLink}
        >
          <LinkedinIcon strokeWidth={1} />
          Share this on LinkedIn
        </LinkedinShareButton>
      </div>
    );
  }
}

export default SocialShare;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachHero/SocialShare/SocialShare.js